import type { GestorEquipeDetail } from '@/services/gestoresService'

export type PjFeriasResumoView = NonNullable<GestorEquipeDetail['feriasResumo']>

export function formatPtDate(value: string | null | undefined): string {
  if (!value) return '—'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return '—'
  return date.toLocaleDateString('pt-BR')
}

export function extractSolicitacaoFeriasPeriod(
  type: string,
  formData: Record<string, unknown>,
): { inicio: string | null; fim: string | null; dias: number | null; resumo: string | null } {
  if (type === 'P6_NOVA') {
    return {
      inicio: typeof formData.periodoInicio === 'string' ? formData.periodoInicio : null,
      fim: typeof formData.periodoFim === 'string' ? formData.periodoFim : null,
      dias: null,
      resumo: typeof formData.resumo === 'string' ? formData.resumo : null,
    }
  }

  if (type === 'P3_ENTRADA_PARCEIRO') {
    const diasRaw = formData.diasCorridos
    const dias = typeof diasRaw === 'number' ? diasRaw : Number(diasRaw)
    return {
      inicio: typeof formData.dataInicioPausa === 'string' ? formData.dataInicioPausa : null,
      fim: typeof formData.dataRetornoPrevisto === 'string' ? formData.dataRetornoPrevisto : null,
      dias: Number.isFinite(dias) ? dias : null,
      resumo: typeof formData.resumo === 'string' ? formData.resumo : null,
    }
  }

  return { inicio: null, fim: null, dias: null, resumo: null }
}

export const FERIAS_STATUS_LABELS: Record<string, string> = {
  SOLICITADO: 'Solicitado',
  APROVADO: 'Aprovado',
  EM_ANDAMENTO: 'Em andamento',
  CONCLUIDO: 'Concluído',
  REJEITADO: 'Rejeitado',
  CANCELADO: 'Cancelado',
}

export const CHAMADO_STATUS_LABELS: Record<string, string> = {
  NOVO: 'Novo',
  EM_ANDAMENTO: 'Em andamento',
  AGUARDANDO_CLIENTE: 'Aguardando',
  PAUSADO: 'Pausado',
  CONCLUIDO: 'Concluído',
  CANCELADO: 'Cancelado',
}
